export default __webpack_public_path__ + "static/media/CARO APOIO COCÇÃO DIVERSOS.0d498c9a.png";